'use strict'

export default typeof Blob !== 'undefined' ? Blob : null



//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/platform/browser/classes/Blob.js
// module id = 59
// module chunks = 0